import Menu from '@components/v2/ui/Menu/Menu';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Typography from '@components/v2/ui/Typography/Typography';
import { getAnchoredPaperSpacing } from '@components/v2/ui/utils/anchoredPaperSpacing';
import * as React from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { OrderActionProps } from '../../../../actions/types/orderActionsContext.types';
import { useOrderActionsContext } from '../../../../contexts/OrderActions.context';
import useOrderSummary from '../../../../contexts/hooks/useOrderSummary';
import { Order } from '../../../../order.types';
import MoreActionsMenuItem from './MoreActionsMenuItem';

interface MoreActionsMenuProps {
  moreActionsAnchorEl: HTMLButtonElement | null;
  onClickMoreActions: (event: React.MouseEvent<HTMLButtonElement> | null) => void;
  order: Order;
}

const MENU_MIN_WIDTH_IN_PIXELS = 205;

const MoreActionsMenu = ({
  moreActionsAnchorEl,
  onClickMoreActions,
  order,
}: MoreActionsMenuProps) => {
  const { translate } = useTranslation();
  const summary = useOrderSummary();

  const { onClickOrderAction } = useOrderActionsContext();

  const openMoreActions = Boolean(moreActionsAnchorEl);

  return (
    <Menu
      open={openMoreActions}
      anchorEl={moreActionsAnchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          sx: [
            getAnchoredPaperSpacing({ variant: 'dropdown' }),
            { minWidth: MENU_MIN_WIDTH_IN_PIXELS },
          ],
        },
      }}
      onClose={() => onClickMoreActions(null)}
    >
      {summary?.moreActions?.map((action) => (
        <MoreActionsMenuItem
          testId={`order-action-${action.value}`}
          label={translate(action.label)}
          icon={action.icon}
          key={action.value}
          setAnchorEl={(event: React.MouseEvent<HTMLButtonElement> | null) => {
            onClickMoreActions(event);
          }}
          onClickMenuItem={() =>
            onClickOrderAction(action.value, OrderActionProps.orderToProps(order))
          }
        />
      ))}

      {!summary?.moreActions && (
        <MenuItem>
          <Typography variant="inherit">
            {translate(LangEnum.ORDER_SUMMARY_NO_AVAILABLE_OPTIONS)}
          </Typography>
        </MenuItem>
      )}
    </Menu>
  );
};

export default MoreActionsMenu;
